/**
 * Celebrate Video Block — Frontend Script
 *
 * Behaviour:
 *   • Default "All" active → shows first visibleCount cards.
 *     Button label = "Show All". Click → shows all, label = "Show Less".
 *   • Specific category click → shows only matching cards, hides button.
 *   • "All" click → restores Show All / Show Less toggle.
 *   • If buttonLink is set → <a> tag just navigates, no toggle.
 */
( function () {
	'use strict';

	function initCelebrateBlocks() {
		document.querySelectorAll( '.celebrate-video-section' ).forEach( function ( section ) {
			var grid       = section.querySelector( '.celebrate-cards-grid' );
			var viewBtn    = section.querySelector( '.celebrate-view-btn' );
			var cta        = section.querySelector( '.celebrate-cta' );
			var filterBtns = Array.from( section.querySelectorAll( '.cvb-filter-btn' ) );

			if ( ! grid ) return;

			var visibleCount = parseInt( grid.dataset.visibleCount, 10 ) || 5;
			var cards        = Array.from( grid.querySelectorAll( '.celebrate-card' ) );
			var expanded     = false;
			var currentCat   = 'all';
			var isLinkBtn    = viewBtn && viewBtn.tagName === 'A';
			var showAllText  = viewBtn ? ( viewBtn.dataset.text || viewBtn.textContent.trim() ) : 'Show All';
			var showLessText = 'Show Less';

			/* ── Initial state: hide cards beyond visibleCount ── */
			cards.forEach( function ( card, i ) {
				if ( i >= visibleCount ) {
					card.classList.add( 'celebrate-card--hidden' );
				}
			} );

			/* Show / hide the CTA based on whether there are hidden cards */
			var hasHiddenCards = cards.length > visibleCount;
			if ( cta && ! isLinkBtn ) {
				cta.style.display = hasHiddenCards ? '' : 'none';
			}

			/* ── Show All / Show Less toggle (button element only) ── */
			if ( viewBtn && ! isLinkBtn ) {
				viewBtn.addEventListener( 'click', function () {
					if ( currentCat !== 'all' ) return;

					expanded = ! expanded;

					cards.forEach( function ( card, i ) {
						if ( i >= visibleCount ) {
							card.classList.toggle( 'celebrate-card--hidden', ! expanded );
						}
					} );

					viewBtn.textContent = expanded ? showLessText : showAllText;
				} );
			}

			/* ── Category filter clicks ── */
			filterBtns.forEach( function ( btn ) {
				btn.addEventListener( 'click', function () {
					var cat = ( this.dataset.category || 'all' ).trim();
					currentCat = cat;

					/* Update active tab */
					filterBtns.forEach( function ( b ) {
						b.classList.remove( 'cvb-filter-active' );
						b.setAttribute( 'aria-selected', 'false' );
					} );
					this.classList.add( 'cvb-filter-active' );
					this.setAttribute( 'aria-selected', 'true' );

					if ( cat === 'all' ) {
						/* Restore Show All / Show Less state */
						cards.forEach( function ( card, i ) {
							card.classList.remove( 'cvb-cat-hidden' );
							if ( i >= visibleCount && ! expanded ) {
								card.classList.add( 'celebrate-card--hidden' );
							} else {
								card.classList.remove( 'celebrate-card--hidden' );
							}
						} );

						/* Show button if needed */
						if ( cta && ! isLinkBtn ) {
							cta.style.display = hasHiddenCards ? '' : 'none';
							if ( viewBtn ) {
								viewBtn.textContent = expanded ? showLessText : showAllText;
							}
						}

					} else {
						/* Show only matching cards, hide the toggle button */
						cards.forEach( function ( card ) {
							var cardCat = ( card.dataset.category || '' ).trim();
							card.classList.remove( 'celebrate-card--hidden' );
							if ( cardCat === cat ) {
								card.classList.remove( 'cvb-cat-hidden' );
							} else {
								card.classList.add( 'cvb-cat-hidden' );
							}
						} );

						if ( cta && ! isLinkBtn ) {
							cta.style.display = 'none';
						}
					}
				} );
			} );
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initCelebrateBlocks );
	} else {
		initCelebrateBlocks();
	}
} )();
